import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { HeaderComponent } from './shared/layout/header/header.component';
import { FooterComponent } from './shared/layout/footer/footer.component';
import { StateService } from './products/services/state.service';
import { SessionService } from './shared/services/session.service';
import { ProductService } from './shared/services/product.service';
import { InstitutionService } from './products/services/institution.service';
import { DateService } from './products/services/date.service';
import { MetricService } from './products/services/metric.service';
import { TourService } from './shared/services/tour.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, HeaderComponent, FooterComponent, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private stateService = inject(StateService);
  private sessionService = inject(SessionService);
  private productService = inject(ProductService);
  private institutionService = inject(InstitutionService);
  private dateService = inject(DateService);
  private metricService = inject(MetricService);

  private router = inject(Router);
  private tourService = inject(TourService);

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.tourService.checkTour(event.urlAfterRedirects);
      }
    });
  }
}
